'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import type { PocBlocksSuggestionLabels } from '../utils/findingSuggestionFieldUtils';

export function usePocBlocksSuggestionLabels(): PocBlocksSuggestionLabels {
  const tPoc = useTranslations('designSystem.findings.structuredPocEditor');
  const tArtifacts = useTranslations('designSystem.artifacts');

  return useMemo(
    () => ({
      image: tPoc('image'),
      whyItMatters: tPoc('whyItMatters'),
      request: tArtifacts('request'),
      response: tArtifacts('response'),
    }),
    [tArtifacts, tPoc],
  );
}
